export const environment = {
  production: true,
  baseUrl: "https://remote-ag-merchant-admin-dev.dojo.dev",
  googleProviderId: '910697999001-b50sh2msae74j448jts06620cl5ect3e.apps.googleusercontent.com',
  name: "Build",
  color: "accent",
};
